import styled from 'styled-components';
import { breakpoints } from '../../styles/theme';
import CheckoutTitleTemplate from './CheckoutTitleTemplate';
import { rem } from 'polished';

export const CheckoutTitleStyled = styled(CheckoutTitleTemplate)`
    font-size: ${rem(22)};
    text-transform: uppercase;
    margin: ${rem(25)} auto;
    text-align: center;
    border-bottom: 1px solid ${({ theme }) => theme.colors.grey3};
    padding-bottom: ${rem(25)};

    @media (min-width: ${breakpoints.sm}px) {
        max-width: ${rem(736)};
        text-align: left;
        border-bottom: none;
        padding-bottom: 0;
        font-size: ${rem(28)};
        padding-left: ${rem(16)};
    }

    @media (min-width: 1024px) {
        max-width: ${rem(976)};
    }

    @media (min-width: ${breakpoints.lg}px) {
        max-width: ${rem(1140)};
    }
`;
